import React from "react";
import styled from "styled-components";

import { Dimensions } from "@util/types";
import {
  colorsRGB,
  BUTTON_HEIGHT,
  MOBILE_BREAKPOINT,
  fontSizes,
  DEFAULT_FONT,
} from "@util/constants";

const StyledInput = styled.input<{
  dimensions?: Dimensions;
  margin?: string;
  fontSize?: number;
  mobileMargin?: string;
  hidden?: boolean;
  width?: string;
}>`
  ${({ margin }) => margin && `margin: ${margin};`}
  ${({ dimensions }) => (dimensions ? `width: ${dimensions.width};` : "100%;")}
  ${({ hidden }) => hidden && `display: none;`}
  width: ${props => props.width ?? "100%"};
  font-size: ${props => props.fontSize ?? fontSizes.p.default}px;
  height: ${props => props.dimensions?.height ?? `${BUTTON_HEIGHT}px`};
  display: flex;
  flex: 1;
  border: none;
  background-color: transparent;
  border-bottom: 1px solid ${colorsRGB.merlin(0.43)};
  font-weight: "normal";
  color: var(--theme-primary-color);
  &:focus {
    outline: 0;
  }
  &::-webkit-input-placeholder {
    opacity: 0.4;
    font-family: ${DEFAULT_FONT};
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    width: 90%;
    ${({ mobileMargin }) => mobileMargin && `margin: ${mobileMargin};`}
  }
`;

const StyledTextArea = styled.textarea<{
  dimensions?: Dimensions;
  hidden?: boolean;
  fontSize?: number;
}>`
  display: flex;
  flex: 1;
  ${({ dimensions }) => (dimensions ? `width: ${dimensions.width};` : "100%;")}
  ${({ hidden }) => hidden && `display: none;`}
  height: ${props => props.dimensions?.height ?? `${BUTTON_HEIGHT}px`};
  border: none;
  border-bottom: 1px solid ${colorsRGB.merlin(0.43)};
  font-weight: "normal";
  margin-top: 30px;
  font-size: ${props => props.fontSize ?? fontSizes.p.default}px;

  &:focus {
    outline: 0;
  }
  &::-webkit-input-placeholder {
    opacity: 0.4;
    font-family: ${DEFAULT_FONT};
  }
`;

const StyledSpan = styled.span`
  position: absolute;
  top: 4px;
  left: 0;
  height: 16px;
  width: 16px;
  border: 1.5px solid ${colorsRGB.black(0.4)};
  :after {
    content: "";
    position: absolute;
    display: none;
    font-weight: "normal";
  }
`;

interface Props {
  dimensions?: Dimensions;
  mobileMargin?: string;
  margin?: string;
  fontSize?: number;
  placeholder?: string;
  name?: string;
  onChange?: (arg?: any) => void;
  value?: string;
  isTextArea?: boolean;
  type?: string;
  required?: boolean;
  hidden?: boolean;
  isCheckbox?: boolean;
  width?: string;
}

const TextInput = (props: Props) => {
  if (props.isTextArea) {
    return (
      <StyledTextArea
        name={props.name}
        placeholder={props.placeholder}
        onChange={props.onChange}
        value={props.value}
        dimensions={props.dimensions}
        hidden={props.hidden}
      />
    );
  }
  if (props.isCheckbox) {
    return (
      <>
        <input
          name={props.name}
          placeholder={props.placeholder}
          onChange={props.onChange}
          value={props.value}
          type="checkbox"
        />
        <StyledSpan />
      </>
    );
  }

  return (
    <StyledInput
      required={props.required}
      name={props.name}
      fontSize={props.fontSize}
      margin={props.margin}
      mobileMargin={props.mobileMargin}
      placeholder={props.placeholder}
      onChange={props.onChange}
      value={props.value}
      dimensions={props.dimensions}
      type={props.type}
      hidden={props.hidden}
      width={props.width}
    />
  );
};

export default TextInput;
